import * as React from "react";
import { Theme, createStyles } from '@mui/material/styles';
import { withStyles, WithStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import { IGenericUserProps, genericMapStateToProps } from "../../../../DataClasses/GenericUser";
import { connect } from "react-redux";
import {
    Grid2 as Grid, Button, Stepper, Typography, Step, StepLabel, CardContent, Card, CircularProgress,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Box, Slider
} from '@mui/material';
import idssStyle from "../../../../Configuration/SharedStyling";
import {
    Check as CheckIcon,
    Edit as EditIcon,
    CloudDownload as CloudDownloadIcon,
    ZoomIn as ZoomInIcon,
    ZoomOut as ZoomOutIcon,
    NavigateNext as NextPageIcon,
    NavigateBefore as PrevPageIcon
} from '@mui/icons-material';
import SubmissionsService from '../../../Services/SubmissionsService';
import { AjaxError } from "rxjs/ajax";
// add rxjs promise replacement
import { firstValueFrom } from "rxjs";
import { Document, Page, pdfjs } from 'react-pdf';
import saveAs from 'file-saver';
import SharedUtility from "../../../../Utilities/SharedUtility";
import { SlideProps } from '@mui/material/Slide';
import Slide from '@mui/material/Slide';
import UserMessage from "../../../Shared/Message";
import { MessageType } from "../../../../DataClasses/SharedData";
import ConfettiExplosion from 'react-confetti-explosion';
import { UserEmail } from "../../../../Configuration/AuthorizationPolicies";

// Configure PDF.js worker - use local worker file to avoid CORS issues
// This points to the worker file we copied to the public directory
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.mjs`;

const Transition = React.forwardRef<unknown, SlideProps>((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const styles = (theme: Theme) => createStyles({
    ...idssStyle(theme),
    root: {
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    optionCard: {
        textAlign: "center",
        alignItems: "center",
        "& p": {
            textAlign: "left",
            padding: theme.spacing(2, 1)
        }
    },
    progress: {
        verticalAlign: 'middle',
        paddingLeft: '5px'
    },
    pdfControls: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(2),
        flexWrap: 'wrap',
        gap: theme.spacing(1)
    },
    pdfPaginationControls: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: theme.spacing(2)
    },
    pdfZoomControls: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    pdfContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        marginBottom: theme.spacing(3),
        '& .react-pdf__Document': {
            maxWidth: '100%',
            overflow: 'auto'
        },
        '& .react-pdf__Page': {
            boxShadow: '0 0 8px rgba(0, 0, 0, 0.2)',
            margin: theme.spacing(2, 0)
        }
    },
    zoomSlider: {
        width: '120px',
        margin: theme.spacing(0, 2)
    },
    pageInfo: {
        margin: theme.spacing(0, 2)
    },
    actionButtonsContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2),
        '& .MuiButton-root': {
            marginRight: theme.spacing(2),
            marginBottom: theme.spacing(1)
        }
    },    
    optionButton: {
        width: "50%",
        color: '#000 !important',
        backgroundColor: '#ccc !important',
        '&:hover': {
        backgroundColor: '#bbb !important',
        },
    },
    selectedOptionButton: {
        width: "50%",
        color: '#fff',
        backgroundColor: '#0099CC',
        '&:hover': {
        backgroundColor: '#4F758B',
        },
    },
});

type IStylesProps = WithStyles<typeof styles>;

interface ILocalProps {
    submissionId: number,
    component: string,
    title: string,
    description: string,
    isPublicReporting?: boolean,
    canManagePublicReporting: boolean,
    canEsignAttestation: boolean,
    isYesAllowed: boolean,
    isLtss: boolean,
    onComplete: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
    onCancel: React.MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
}

interface ILocalState {
    activeStep: number,
    isPublicReporting?: boolean,
    isSaving: boolean,
    encodedPreviewPDF: string,
    encodedSignedPDF: string,
    isDownloadingDocument: boolean,
    attestationModifiedDate?: Date,
    isEsignInProgress: boolean,
    isLoading: boolean,
    isExploding: boolean,
    lastClickedTime: number,
    isGeneratingPdf: boolean,
    showEsignDialog: boolean,
    publicReportingDialogOpen: boolean,
    // PDF viewer state
    pdfPageNumber: number,
    pdfNumPages: number,
    pdfScale: number,
    // Memoized PDF data to prevent unnecessary reloads
    pdfData: Uint8Array | null,
    // Memoized file object for react-pdf
    pdfFileObject: { data: Uint8Array } | null
}


class AttestationStepsView extends React.Component<IGenericUserProps & IStylesProps & ILocalProps, ILocalState> {
    constructor(props: IGenericUserProps & IStylesProps & ILocalProps) {
        super(props);


        this.state = {
            activeStep: 0,
            isPublicReporting: this.props.isPublicReporting,
            isSaving: false,
            encodedPreviewPDF: null,
            encodedSignedPDF: null,
            isDownloadingDocument: false,
            isEsignInProgress: false,
            isLoading: false,
            isExploding: false,
            lastClickedTime: new Date().getTime(),
            isGeneratingPdf: false,
            showEsignDialog: false,
            publicReportingDialogOpen: false,
            // PDF viewer state initialization
            pdfPageNumber: 1,
            pdfNumPages: 0,
            pdfScale: 1.0,
            // Initialize memoized PDF data
            pdfData: null,
            // Initialize memoized file object
            pdfFileObject: null
        };
    }

    public async componentDidMount() {
        await this.RefreshModel();
    }

    public componentDidUpdate(prevProps: IGenericUserProps & IStylesProps & ILocalProps, prevState: ILocalState) {
        // Update memoized PDF data when encodedPreviewPDF changes
        if (this.state.encodedPreviewPDF !== prevState.encodedPreviewPDF) {
            this.updatePdfData();
        }
    }

    private updatePdfData = () => {
        if (this.state.encodedPreviewPDF) {
            // Convert base64 to Uint8Array and memoize it
            const pdfData = new Uint8Array(atob(this.state.encodedPreviewPDF).split("").map(c => c.charCodeAt(0)));
            // Create a memoized file object to prevent unnecessary reloads
            const pdfFileObject = { data: pdfData };
            this.setState({ pdfData, pdfFileObject });
        } else {
            this.setState({ pdfData: null, pdfFileObject: null });
        }
    };

    public render() {
        const { classes } = this.props;
        const steps = this.getSteps();


        return (<div className={classes.root}>
            <Stepper activeStep={this.state.activeStep} alternativeLabel >
                {steps.map(label => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <div>
                {this.state.encodedSignedPDF ? (
                    <Card elevation={4}>
                        <CardContent>
                            {/*<Typography className={classes.instructions} color="primary" variant="h6">*/}
                            {/*    <CheckIcon />*/}
                            {/*    Signature Applied*/}
                            {/*</Typography>*/}
                            {this.state.isExploding && <ConfettiExplosion />}

                            <div className={classes.instructions}>
                                <UserMessage text={this.getUserInfoMessage()} variant={MessageType.Warning} />
                            </div>

                            <div className={classes.actionButtonsContainer}>
                                <Button onClick={this.downloadSignedDocument} disabled={!this.state.encodedSignedPDF} startIcon={<CloudDownloadIcon />}>Download Document</Button>
                                <Button onClick={this.handleFinish} disabled={!this.state.encodedSignedPDF} startIcon={<CheckIcon />}>Finish</Button>
                            </div>
                        </CardContent>
                    </Card>
                ) : (
                    <div>
                        <Typography className={classes.instructions}>{this.getStepContent(this.state.activeStep)}</Typography>
                        <div className={classes.actionButtonsContainer}>
                            <Button
                                disabled={this.state.activeStep === 0 || this.state.isGeneratingPdf}
                                onClick={this.handleBack}
                                className={classes.backButton}
                            >
                                Back
                            </Button>
                            {this.state.activeStep === this.REVIEW_AND_SIGN_STEP ? (
                                <Tooltip title={(this.isCurrentStepInValid() || !this.props.canEsignAttestation) ? "Only available for Signer" : ""}>
                                    <span>
                                        <Button onClick={this.downloadPreviewDocument} disabled={!this.state.encodedPreviewPDF} startIcon={<CloudDownloadIcon />}>Download Draft Document</Button>

                                        <Button
                                            onClick={this.showEsignDialog.bind(this)}
                                            color="primary"
                                            variant="contained"
                                            startIcon={<EditIcon />}
                                            disabled={(this.isCurrentStepInValid() || !this.props.canEsignAttestation)}
                                        >
                                            Sign
                                        </Button>
                                        <Dialog
                                            open={this.state.showEsignDialog}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                            TransitionComponent={Transition}
                                        >
                                            <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>Esign Confirmation</Typography></DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    <Typography component="div" className={classes.secondaryText}>
                                                        By clicking "SIGN", you agree and consent:<br></br>
                                                        <ul style={{ listStyleType: "lower-roman" }}>
                                                            <li>To contract electronically with NCQA as related to the Attestation; </li>
                                                            <li>You are duly authorized to enter into and bind your organization, as applicable, to the Attestation; and </li>
                                                            <li>That by clicking "SIGN," you and/or your organization agree to be bound by the Attestation.</li>
                                                        </ul>
                                                    </Typography>
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={this.hideEsignDialog.bind(this)} className={classes.disabledButton}>
                                                    Cancel
                                                </Button>
                                                <Button onClick={() => this.handleSign()} autoFocus disabled={this.state.isEsignInProgress}>
                                                    Sign
                                                </Button>
                                                {this.state.isEsignInProgress ? <span className={classes.progress}><CircularProgress color="primary" size={22} /></span> : null}
                                            </DialogActions>
                                        </Dialog>
                                    </span>
                                </Tooltip>)
                                : this.state.activeStep === this.PUBLIC_REPORTING_STEP ? (
                                    <span>
                                        <Button variant="contained" color="primary" onClick={() => this.props.isYesAllowed === true ? this.setState({ publicReportingDialogOpen: true }) : this.handleNext(this.REVIEW_AND_SIGN_STEP)}
                                            disabled={!this.props.canManagePublicReporting || this.state.isGeneratingPdf || !this.isEnableNext()}
                                            className={classes.button}>
                                            Next
                                        </Button>

                                        <Dialog
                                            open={this.state.publicReportingDialogOpen}
                                            aria-labelledby="alert-dialog-title"
                                            aria-describedby="alert-dialog-description"
                                        >
                                            <DialogTitle id="alert-dialog-title"><Typography className={classes.primaryBlueSmall}>Public Reporting Confirmation</Typography></DialogTitle>
                                            <DialogContent>
                                                <DialogContentText id="alert-dialog-description">
                                                    <Typography className={classes.secondaryText}>
                                                        You have selected {this.getPublicsReportingDisplay()} to Public Reporting in HPR and QC. Are you sure? <br />
                                                        Please read the public reporting option details carefully. After the submission deadline, no corrections can be made.
                                                    </Typography>
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={() => this.cancelPublicReporting()} className={classes.disabledButton}>
                                                    Cancel
                                                </Button>
                                                <Button onClick={() => this.handleNext(this.REVIEW_AND_SIGN_STEP)} autoFocus disabled={this.state.isEsignInProgress}>
                                                    Save
                                                </Button>
                                                {this.state.isEsignInProgress ? <span className={classes.progress}><CircularProgress color="primary" size={22} /></span> : null}
                                            </DialogActions>
                                        </Dialog>
                                    </span>)
                                    : ((!this.props.canManagePublicReporting || this.state.isGeneratingPdf) && !this.state.isGeneratingPdf) ?
                                        <div>
                                            <Typography color="secondary" variant="h6">
                                                You must select or reselect your option to proceed
                                            </Typography>
                                            {/* DEBUG: Show permission details */}
                                            <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#fff3e0', border: '1px solid #ff9800' }}>
                                                <Typography variant='caption' color='textSecondary'>
                                                    <strong>Permission Debug Info:</strong><br />
                                                    Can Manage Public Reporting: {this.props.canManagePublicReporting ? 'Yes' : 'No'}<br />
                                                    Is Generating PDF: {this.state.isGeneratingPdf ? 'Yes' : 'No'}<br />
                                                    User Email: {UserEmail(this.props.user) || 'Unknown'}<br />
                                                    Component: {this.props.component}<br />
                                                    Submission ID: {this.props.submissionId}
                                                </Typography>
                                            </div>
                                        </div> : null
                            }
                            {this.state.isGeneratingPdf ? <span className={classes.progress}><CircularProgress color="primary" size={22} /></span> : null}

                        </div>
                    </div>
                )}
            </div>
        </div>);
    }

    private async RefreshModel() {

    }

    private showEsignDialog() {
        this.setState({ showEsignDialog: true });
    }

    private hideEsignDialog() {
        this.setState({ showEsignDialog: false });
    }

    private PUBLIC_REPORTING_STEP: number = 0;
    private REVIEW_AND_SIGN_STEP: number = 1;
    private getSteps() {
        return ['Public Reporting', 'Review and Sign'];
    }

    private getStepContent(stepIndex: number) {
        switch (stepIndex) {
            case this.PUBLIC_REPORTING_STEP:
                return this.getPublicReportingStep();
            case this.REVIEW_AND_SIGN_STEP:
                return this.getReviewAndSignStep();
            default:
                return 'Unknown stepIndex';
        }
    }

    private getUserInfoMessage = () => {
        return (
            <Typography variant='body2' color='inherit'>
                Your signature has been applied. Click "FINISH" to complete the attestation process and finalize the submission. You may download your signed document now, or come back later to download it from the All Downloads tab.
            </Typography>
        );
    }

    private getPublicReportingStep = () => {
        const { classes } = this.props;
        let noText = "No"; //It's about the display of the Yes option, however, the text defaults to No for this case.
        if (!this.props.isYesAllowed) {
            noText = "Acknowledge";
        }

        return (
            <Grid key="publicReportingStep" container={true} spacing={2}>
                {this.props.isYesAllowed ?
                    <Grid key="yesOption" size={6} className={classes.gridDisplay}>
                        <Card className={classes.optionCard} elevation={4}>
                            <CardContent>
                                <Button
                                    onClick={() => this.handlePublicReportingOption(true)}
                                    variant="contained"
                                    className={
                                    `${classes.button} ${
                                    this.state.isPublicReporting
                                        ? classes.selectedOptionButton
                                        : classes.optionButton
                                    }`
                                }
                                    startIcon={this.state.isPublicReporting ? <CheckIcon /> : null}
                                    disabled={!this.props.canManagePublicReporting || !this.props.isYesAllowed}
                                >
                                    Yes
                                </Button>
                                {this.props.isLtss ?
                                    <Typography variant='body2' color='textPrimary'>
                                        I agree that the Data, including Organization or product identifying data, <strong>will</strong> be publicly reported by NCQA and <strong>will</strong> be included in NCQA published products and reports <strong>(e.g., <em>Quality Compass® and similar products</em>)</strong> and the publications of licensees of NCQA. NCQA and its licensees may also report and include the Data as part of roll-up or composite results and reporting categories which may include assigning designations or summary conclusions to Organization's performance based on the Data. Organization acknowledges that NCQA may also choose, at its option, not to publicly report certain Data.
                                    </Typography>
                                    :
                                    <Typography variant='body2' color='textPrimary'>
                                        I agree that the Data, including Organization or product identifying data, <strong>will</strong> be publicly reported by NCQA and <strong>will</strong> be included in NCQA published products and reports <strong>(e.g., <em>Quality Compass®, NCQA's Health Plan Report Card, NCQA's Health Plan Ratings, or similar products</em>)</strong> and the publications of licensees of NCQA. NCQA and its licensees may also report and include the Data as part of roll-up or composite results and reporting categories which may include assigning designations or summary conclusions to Organization's performance based on the Data. Organization acknowledges that NCQA may also choose, at its option, not to publicly report certain Data.
                                    </Typography>}
                            </CardContent>
                        </Card>
                    </Grid>
                    : null}
                <Grid key="noOption" size={6} className={classes.gridDisplay}>
                    <Card className={classes.optionCard} elevation={4}>
                        <CardContent>
                            <Button
                                onClick={() => this.handlePublicReportingOption(false)}
                                startIcon={this.state.isPublicReporting === false ? <CheckIcon /> : null}
                                variant="contained"
                                className={
                                    `${classes.button} ${
                                    this.state.isPublicReporting === false
                                        ? classes.selectedOptionButton
                                        : classes.optionButton
                                    }`
                                }
                                disabled={!this.props.canManagePublicReporting}
                            >
                                {noText}
                            </Button>
                            {/* Show button disable reasons (removed debug info) */}
                            {this.props.isYesAllowed ?
                                (this.props.isLtss ?
                                    <Typography variant='body2' color='textPrimary'>
                                        Except as otherwise provided in this ATTESTATION and in an Accreditation contract with NCQA, the Data will not be included in NCQA published products and reports <strong>(e.g., <em>Quality Compass® and similar products</em>)</strong>. I understand that NCQA may include the Data in published aggregate statistics and benchmarks without my further permission.
                                    </Typography>
                                    :
                                    <Typography variant='body2' color='textPrimary'>
                                        Except as otherwise provided in this ATTESTATION and in an Accreditation contract with NCQA, the Data will not be included in NCQA published products and reports <strong>(e.g., <em>Quality Compass®, NCQA's Health Plan Report Card, NCQA's Health Plan Ratings, or similar products</em>)</strong>. I understand that by indicating that I <strong>do not</strong> wish to publicly report the Data, the Organization will be rated by NCQA in its annual rating of health plans at the bottom of the list under the heading of health plans that did not provide HEDIS data or did not permit their HEDIS data to be made public. I understand that NCQA may include the Data in published aggregate statistics and benchmarks without my further permission.
                                    </Typography>
                                )
                                :
                                !this.props.isLtss ?
                                    <Typography variant='body2' color='textPrimary'>
                                        You also acknowledge and agree that NCQA may use and include the Data (to include plan-specific identifiers) in published products and reports <strong>(e.g., NCQA's <em>Quality Compass, NCQA's Health Plan Report Card, NCQA's Health Plan Ratings, or similar products</em>)</strong> if the Data (to include plan-specific identifiers) is made publicly available by a third party with the right to publish said Data (to include plan-specific identifiers).
                                    </Typography> :
                                    <Typography variant='body2' color='textPrimary'>
                                        You acknowledge and agree that NCQA may: (1) use the Data for research purposes, so long as all plan-specific identifiers are removed in publications; (2) release the Data to third parties for research, so long as such third parties have entered into a confidentiality agreement with NCQA and all plan-specific identifiers are removed in publications; (3) include/use the aggregate statistics and benchmarks of the Data in NCQA published products and reports <strong>(e.g., NCQA's <em>Quality Compass, NCQA's Health Plan Report Card, NCQA's Health Plan Ratings, or similar products</em>)</strong> and (4) be used for scoring organizations seeking NCQA's LTSS Accreditation or Distinction programs that voluntarily choose to submit performance results on the HEDIS LTSS Measures instead of providing a documented process or completing file review for certain requirements.
                                    </Typography>
                            }
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

        );
    }

    private getReviewAndSignStep = () => {
        const { classes } = this.props;
        if (SharedUtility.IsNullOrUndefined$(this.state.encodedPreviewPDF)) {
            return (
                <Card className={classes.optionCard} elevation={4}>
                    <CardContent>
                        <CircularProgress color="secondary" size={20} />
                    </CardContent>
                </Card>
            )
        }

        return (
            <Card className={classes.optionCard} elevation={4}>
                <CardContent>
                    <Box className={classes.pdfContainer}>
                        <Document
                            file={this.state.pdfFileObject}
                            loading={<CircularProgress color="secondary" size={20} />}
                            error={<Typography color="error">Failed to load PDF preview.</Typography>}
                            onLoadSuccess={this.onDocumentLoadSuccess}>
                            <Page
                                pageNumber={this.state.pdfPageNumber}
                                scale={this.state.pdfScale}
                                loading={<CircularProgress color="secondary" size={20} />}
                                renderTextLayer={false}
                                renderAnnotationLayer={false}
                            />
                        </Document>
                    </Box>
                    <Box className={classes.pdfControls}>
                        <Box className={classes.pdfPaginationControls}>
                            <IconButton
                                disabled={this.state.pdfPageNumber <= 1}
                                onClick={this.handlePrevPage}
                                size="small"
                                color="primary"
                            >
                                <PrevPageIcon />
                            </IconButton>
                            <Typography className={classes.pageInfo} variant="body2">
                                Page {this.state.pdfPageNumber} of {this.state.pdfNumPages || '?'}
                            </Typography>
                            <IconButton
                                disabled={this.state.pdfPageNumber >= this.state.pdfNumPages}
                                onClick={this.handleNextPage}
                                size="small"
                                color="primary"
                            >
                                <NextPageIcon />
                            </IconButton>
                        </Box>
                        <Box className={classes.pdfZoomControls}>
                            <IconButton onClick={this.handleZoomOut} size="small" color="primary">
                                <ZoomOutIcon />
                            </IconButton>
                            <Slider
                                className={classes.zoomSlider}
                                value={this.state.pdfScale * 100}
                                min={50}
                                max={200}
                                step={10}
                                onChange={this.handleZoomChange}
                                aria-labelledby="zoom-slider"
                            />
                            <IconButton onClick={this.handleZoomIn} size="small" color="primary">
                                <ZoomInIcon />
                            </IconButton>
                            <Typography variant="body2">
                                {Math.round(this.state.pdfScale * 100)}%
                            </Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        );
    }

    // PDF controls handlers
    private onDocumentLoadSuccess = ({ numPages }: { numPages: number }) => {
        this.setState({ pdfNumPages: numPages });
    };

    private handlePrevPage = () => {
        this.setState(prevState => ({
            pdfPageNumber: Math.max(prevState.pdfPageNumber - 1, 1)
        }));
    };

    private handleNextPage = () => {
        this.setState(prevState => ({
            pdfPageNumber: Math.min(prevState.pdfPageNumber + 1, prevState.pdfNumPages)
        }));
    };

    private handleZoomOut = () => {
        this.setState(prevState => ({
            pdfScale: Math.max(prevState.pdfScale - 0.1, 0.5)
        }));
    };

    private handleZoomIn = () => {
        this.setState(prevState => ({
            pdfScale: Math.min(prevState.pdfScale + 0.1, 2.0)
        }));
    };

    private handleZoomChange = (_event: Event, value: number | number[]) => {
        const zoomValue = Array.isArray(value) ? value[0] : value;
        this.setState({
            pdfScale: zoomValue / 100
        });
    };

    private handlePublicReportingOption = (value: boolean) => {
        this.setState({ isPublicReporting: value });
    };

    private handleSave = async () => {
        const attestationFlags: any = {
            submissionId: this.props.submissionId,
            component: this.props.component,
            isPublicReported: this.state.isPublicReporting
        };
        if (this.state.attestationModifiedDate) {
            attestationFlags.sourceLastModified = this.state.attestationModifiedDate;
        }
        try {
            const updateAttestationResult = await firstValueFrom(
                SubmissionsService.UpdateSubmissionAttestationReportingFlags$(
                    this.props.user,
                    attestationFlags
                )
            );
            if (updateAttestationResult instanceof AjaxError) {
                throw new Error("Ajax Error");
            }
        } catch (error) {
            throw error;
        }
    }

    private handleSign = async () => {
        this.setState({ isEsignInProgress: true });
        try {
            const signDocResult = await firstValueFrom(
                SubmissionsService.SignPDF$(this.props.user, this.props.submissionId, this.props.component)
            );
            if (signDocResult) {
                this.setState({
                    encodedSignedPDF: signDocResult.response.toString(),
                    activeStep: 3,
                    isEsignInProgress: false
                });
            } else {
                this.setState({ isEsignInProgress: false });
            }
        } catch {
            this.setState({ isEsignInProgress: false });
        }
    };

    private isEnableNext() {
        const isEnabled = this.props.isYesAllowed ?
            (this.state.isPublicReporting !== undefined && this.state.isPublicReporting !== null) :
            this.state.isPublicReporting === false;


        return isEnabled;
    }
    private cancelPublicReporting = () => {
        this.setState({ isPublicReporting: undefined, publicReportingDialogOpen: false });
    }

    private getPublicsReportingDisplay = () => {
        if (this.state.isPublicReporting === undefined || this.state.isPublicReporting === null) {
            return "NOTHING";
        }
        if (this.state.isPublicReporting === true) {
            return "YES";
        }
        else {
            return "NO";
        }
    }

    private handleNext = async (targetStep: number) => {
        this.setState({ publicReportingDialogOpen: false });
        try {
            await this.handleSave();
        } catch {
            return;
        }
        if (targetStep === this.REVIEW_AND_SIGN_STEP) {
            this.setState({ isGeneratingPdf: true });
            try {
                const retval = await firstValueFrom(
                    SubmissionsService.GetESignPDF$(this.props.user, this.props.submissionId, this.props.component)
                );
                this.setState({
                    isGeneratingPdf: false,
                    activeStep: targetStep,
                    encodedPreviewPDF: retval,
                    pdfPageNumber: 1,
                    pdfNumPages: 0,
                    pdfScale: 1.0
                }, () => this.updatePdfData());
            } catch {
                this.setState({ isGeneratingPdf: false });
            }
        }
    };

    private handleBack = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        if (this.state.activeStep === 0)
            this.props.onCancel(event);
        else {
            this.setState({ activeStep: this.state.activeStep - 1 });
        }
    };

    private handleFinish = (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        this.setState({ isExploding: true });
        this.sleep(10000);
        this.props.onComplete(event);
    };

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    private isCurrentStepInValid = (): boolean => {
        switch (this.state.activeStep) {
            case this.PUBLIC_REPORTING_STEP:
                return SharedUtility.IsNullOrUndefined$(this.state.isPublicReporting);
            case this.REVIEW_AND_SIGN_STEP:
                return SharedUtility.IsNullOrUndefined$(this.state.encodedPreviewPDF);
            default:
                return false;
        }
    }

    private downloadSignedDocument = async (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        this.setState({ isDownloadingDocument: true });

        try {
            if (this.state.encodedSignedPDF) {
                const data = this.str2ab(atob(this.state.encodedSignedPDF));
                saveAs(new Blob([data], { type: "application/pdf" }), this.props.submissionId + "_HEDIS_Signed.pdf");
            }
        }
        catch (ex) {
            console.log(ex);
        }
        finally {
            this.setState({ isDownloadingDocument: false });
        }
    }

    private downloadPreviewDocument = async (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
        this.setState({ isDownloadingDocument: true });

        try {
            if (this.state.encodedPreviewPDF) {
                const data = this.str2ab(atob(this.state.encodedPreviewPDF));
                saveAs(new Blob([data], { type: "application/pdf" }), this.props.submissionId + "_HEDIS_Draft.pdf");
            }
        }
        catch (ex) {
            console.log(ex);
        }
        finally {
            this.setState({ isDownloadingDocument: false });
        }
    }

    private str2ab(str) {
        const buf = new ArrayBuffer(str.length);
        const bufView = new Uint8Array(buf);
        for (let i = 0, strLen = str.length; i < strLen; i++) {
            bufView[i] = str.charCodeAt(i);
        }
        return buf;
    }
}

// REDUX CONTAINER
const AttestationStepsWithState = connect<IGenericUserProps>(genericMapStateToProps)(AttestationStepsView);

// STYLES CONTAINER
const AttestationSteps = withStyles(styles)(AttestationStepsWithState);

// REDUX CONTAINER
export default AttestationSteps;
